import { render } from "./PlatesCreate.vue?vue&type=template&id=728a48aa&scoped=true"
import script from "./PlatesCreate.vue?vue&type=script&lang=js"
export * from "./PlatesCreate.vue?vue&type=script&lang=js"

import "./PlatesCreate.vue?vue&type=style&index=0&id=728a48aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728a48aa"]])

export default __exports__